export const addPartnerModalInitValue = {
  data: {
    name: '',
    cif: '',
    email: '',
    naturalPerson: true,
    isEmailValid: true,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {
      throw new Error('Function not implemented.');
    },
    handleChangeCif(): void {
      throw new Error('Function not implemented.');
    },
    handleChangeEmail(): void {
      throw new Error('Function not implemented.');
    },
    onChangeName(): void {
      throw new Error('Function not implemented.');
    },
    onChangeCif(): void {
      throw new Error('Function not implemented.');
    },
    onChangeEmail(): void {
      throw new Error('Function not implemented.');
    },
    handleChangeNaturalPerson(): void {
      throw new Error('Function not implemented.');
    },
    handleSavePartner(): void {
      throw new Error('Function not implemented.');
    },
  },
};
